module.exports = __webpack_public_path__ + "static/media/RB_new_logo.88c08eaa.png";